"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ActionButtons = void 0;
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _router = require("next/router");
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../../../constants");
var _useTranslations = require("../../../../hooks/useTranslations");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const ActionButtons = (param)=>{
    let { isSaving } = param;
    const { translations } = (0, _useTranslations.useTranslations)();
    const { push } = (0, _router.useRouter)();
    const { getTestId } = (0, _testidGenerator.default)();
    const onCancel = (0, _react.useCallback)(async ()=>{
        await push(_constants.BASE_PATH);
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ButtonWrapper, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                    fullWidth: true,
                    color: "default",
                    variant: "text",
                    "data-testid": getTestId(_constants2.ACTION_BUTTON_CANCEL),
                    onClick: onCancel,
                    children: translations.cancel
                }, "cancel")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ButtonWrapper, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                    fullWidth: true,
                    type: "submit",
                    color: "primary",
                    variant: "contained",
                    loading: isSaving,
                    "data-testid": getTestId(_constants2.ACTION_BUTTON_SAVE),
                    children: translations.saveList
                }, "save")
            })
        ]
    });
};
exports.ActionButtons = ActionButtons;
